export enum ErrorCode {
	GENERIC = 'genericError',
	DUPLICATED_EMAIL = 'duplicatedEmail',
	INVALID_HASH = 'invalidHash',
	INVALID_PASSWORD = 'invalidPassword',
}
